module.exports = __webpack_public_path__ + "images/ba38bffb0e95d7d94b2fa47b5965542cec28e44868984d1b1b04a130326cc023.svg";